import { render, staticRenderFns } from "./MbPresentationsGridElectron.vue?vue&type=template&id=af6ab6c4&"
import script from "./MbPresentationsGridElectron.vue?vue&type=script&lang=js&"
export * from "./MbPresentationsGridElectron.vue?vue&type=script&lang=js&"
import style0 from "./MbPresentationsGridElectron.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports